import CoursePage from './CoursePage';
import CourseMap from './courseMap/CourseMap';
import CourseInfo from './courseInfo/CourseInfo';
import Signposts from './signposts/Signposts';
import Stats from './stats/Stats';
import Favourites from './favourites/Favourites';
import Results from './results/Results';
import CourseRecords from './courseRecords/CourseRecords';
import PageProvider from '../shared/providers/PageProvider';
import TabFetchProvider from '../shared/providers/TabFetchProvider';
import TabProvider from '../shared/providers/TabProvider';

const routes = {
    path: 'course/:id/:name',
    component: PageProvider,
    Page: CoursePage,
    indexRoute: {
        component: TabFetchProvider,
        Tab: Stats,
        fetchPath: 'stats',
    },
    childRoutes: [
        {
            path: 'stats',
            component: TabFetchProvider,
            Tab: Stats,
        },
        {
            path: 'course-map',
            component: TabProvider,
            Tab: CourseMap,
        },
        {
            path: 'course-records',
            component: TabProvider,
            Tab: CourseRecords,
        },
        {
            path: 'favourites',
            component: TabFetchProvider,
            Tab: Favourites,
        },
        {
            path: 'signposts',
            component: TabFetchProvider,
            Tab: Signposts,
        },
        {
            path: 'course-info',
            component: TabProvider,
            Tab: CourseInfo,
        },
        {
            path: 'results',
            component: TabFetchProvider,
            Tab: Results,
        },
    ],
};

export default routes;



// WEBPACK FOOTER //
// ./src/js/course/courseRoutes.js